
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","stroke":"currentcolor","width":"20","height":"20","color":"#e66a5c","fill":"currentcolor","stroke-width":"1.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.625 16.374l8.75-8.75m-7.929 4.394A3.73 3.73 0 005.598 13.1l-1.875 1.875a3.75 3.75 0 005.304 5.303h0l1.875-1.875a3.73 3.73 0 001.083-2.847m3.569-3.576a3.73 3.73 0 002.848-1.083l1.875-1.875a3.75 3.75 0 00-5.304-5.304l-1.875 1.875a3.731 3.731 0 00-1.079 2.848","fill":"none","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    